import { render, staticRenderFns } from "./storeOrderDetail.vue?vue&type=template&id=40c58732&scoped=true&"
import script from "./storeOrderDetail.vue?vue&type=script&lang=js&"
export * from "./storeOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./storeOrderDetail.vue?vue&type=style&index=0&id=40c58732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c58732",
  null
  
)

export default component.exports